import React, {useEffect, useState} from 'react';
import {AddIcon, LoadingIcon} from "../../assets/icons/Icons";
import FormSection from "../form/Section";
import Switch from "../form/Switch";
import FormHeader from "../form/Header";
import Popup from "../Popup";
import { useUserContext } from '../../contexts/UserContext';
import StateSelect from "../form/StateSelect";
import CountrySelect from "../form/CountrySelect";
import OfficesSelect from "../form/OfficesSelect";
import ShippingMethodSelect from "../form/ShippingMethodSelect";
import {CreateShippingAddress} from "../../api/shipping-addresses/createShippingAddress";
import {useTranslation} from "react-i18next";

const CreateShippingAddressForm = ({onCreate, onClose, ...props}) => {

    const { t } = useTranslation();

    const [loading, setLoading] = useState(false);
    const [status, setStatus] = useState(false);
    const [name, setName] = useState('');
    const [office, setOffice] = useState('');
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [address1, setAddress1] = useState('');
    const [address2, setAddress2] = useState('');
    const [postalCode, setPostalCode] = useState('');
    const [state, setState] = useState('');
    const [city, setCity] = useState('');
    const [country, setCountry] = useState('');
    const [shippingMethod, setShippingMethod] = useState('');
    const [submitDisabled, setSubmitDisabled] = useState(false);
    const { userData } = useUserContext();

    const [error, setError] = useState('');
    const [fieldErrors, setFieldErrors] = useState([]);


    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setSubmitDisabled(true);
        try {
            await CreateShippingAddress( status,
                office,
                name,
                firstName,
                lastName,
                userData.company_id,
                address1,
                address2,
                postalCode,
                state,
                city,
                country,
                shippingMethod
            );
            setLoading(false);
            setSubmitDisabled(false);
            onCreate();
        } catch (err){
            setError(err.message);
            if(err.data){
                setFieldErrors(err.data);
            }
            setLoading(false);
            setSubmitDisabled(false);
            console.log("Error fetching data: " + err);
        }
    }

    useEffect(() => {
        if (status && name && firstName && lastName && address1 && postalCode && state && city && country && shippingMethod) {
            setSubmitDisabled(false);
        } else {
            setSubmitDisabled(true);
        }
    }, [status, name, firstName, lastName, address1, postalCode, state, city, country, shippingMethod]);

    return (
        <Popup size="large" withClose withOverlay onClose={onClose}>
            <form method="post" onSubmit={handleSubmit}>

                <FormHeader title={t("Add Shipping Address")}
                            description="Provide detailed and accurate information for efficient delivery."></FormHeader>

                <div className="row mb-5 mt-5 align-items-center">
                    <div className="col-xs-6">
                        <Switch title={t("Active")}>
                            <input type="checkbox" name="status" id="status" onChange={e => {
                                setStatus(e.target.checked)
                            }}/>
                        </Switch>
                    </div>
                </div>

                <div className="row mb-5">
                    <div className="col-xs-6">
                        <FormSection title={t("Office")}>
                            <OfficesSelect
                                onChange={setOffice}
                            />
                        </FormSection>
                    </div>
                    <div className="col-xs-6">
                        <FormSection title={t("Shipping address name")} required>
                            <input type="text" name="name" id="name" maxLength="40" value={name} placeholder={t("Input name")}
                                   onChange={e => setName(e.target.value)}/>
                        </FormSection>
                    </div>
                </div>

                <div className="row mb-5">
                    <div className="col-xs-6">
                        <FormSection title={t("First Name")} required>
                            <input type="text" name="first_name" id="first_name" maxLength="30" value={firstName} placeholder={t("User first name, max 30 characters")}
                                   onChange={e => setFirstName(e.target.value)}/>
                        </FormSection>
                    </div>
                    <div className="col-xs-6">
                        <FormSection title={t("Last Name")} required>
                            <input type="text" name="last_name" id="last_name" maxLength="30" value={lastName} placeholder={t("User last name, max 30 characters")}
                                   onChange={e => setLastName(e.target.value)}/>
                        </FormSection>
                    </div>
                </div>

                <div className="row mb-5">
                    <div className="col-xs-6">
                        <FormSection title={t("Address 1")} required>
                            <input type="text" name="adddress1" id="adddress1" maxLength="40" value={address1} placeholder={t("Input address 1")}
                                   onChange={e => setAddress1(e.target.value)}/>
                        </FormSection>
                    </div>
                    <div className="col-xs-6">
                        <FormSection title={t("Address 2 (Optional)")}>
                            <input type="text" name="address2" id="address2" maxLength="30" value={address2} placeholder={t("Input address 2")}
                                   onChange={e => setAddress2(e.target.value)}/>
                        </FormSection>
                    </div>
                </div>

                <div className="row mb-5">
                    <div className="col-xs-6">
                        <FormSection title={t("Postal Code")} required>
                            <input type="text" name="postalCode" id="postalCode" maxLength="50" value={postalCode} placeholder={t("Input postal Code")}
                                   onChange={e => setPostalCode(e.target.value)}/>
                        </FormSection>
                    </div>
                    <div className="col-xs-6">
                        <FormSection title={t("Province")} required>
                            <StateSelect value={state} onChange={option => setState(option.value)}/>
                        </FormSection>
                    </div>
                </div>

                <div className="row mb-5">
                    <div className="col-xs-6">
                        <FormSection title={t("City")} required>
                            <input type="text" name="city" id="city" maxLength="20" value={city} placeholder={t("Input city")}
                                   onChange={e => setCity(e.target.value)}/>
                        </FormSection>
                    </div>
                    <div className="col-xs-6">
                        <FormSection title={t("Country")} required>
                            <CountrySelect value={country} onChange={option => setCountry(option.value)}/>
                        </FormSection>
                    </div>
                </div>

                <div className="row mb-5">
                    <div className="col-xs-6">
                        <FormSection title={t("Shipping method")} required>
                            <ShippingMethodSelect value={shippingMethod} onChange={option => setShippingMethod(option.value)}/>
                        </FormSection>
                    </div>
                </div>

                <div className="text-right">
                    <button className={`btn btn-primary btn-medium ${loading ? 'btn-loading' : ''}`} type="submit"
                            name="submit" disabled={submitDisabled}>
                        {loading ? <LoadingIcon/> : <AddIcon/>}
                        {t("Add")}
                    </button>
                </div>
                {error && <p className="color-error text-center mt-3">{error}</p>}
                {fieldErrors.map((error) => (
                    <p className="color-error text-center mt-3">{error.message}</p>
                ))}
            </form>
        </Popup>
    );
};

export default CreateShippingAddressForm;